import { handleActions } from 'redux-actions';

import { auth, kickOut, refreshToken, loadInitClientDataSuccess, loadInitClientDataFail } from '../actions/authActions';

const defaultState = {
  isAuthenticated: false
};
export const authReducer = handleActions(
  {
    [auth]: (state, action) => ({
      ...state,
      isAuthenticated: true,
      user: action.payload.user,
      token: action.payload.token,
      refreshToken: action.payload.refreshToken,
      isSignUp: action.payload.isSignUp,
      orgId:action.payload.orgId,
      jobId:action.payload.jobId,
      projectName:action.payload.projectName,
      redirect:action.payload.redirect,
      fail:action.payload.fail
    }),
    [kickOut]: () => ({
      isAuthenticated: false
    }),
    [refreshToken]: (state, action) => ({
      ...state,
      token: action.payload
    }),
    [loadInitClientDataSuccess]: (state, action) => ({
      ...state,
      user: action.payload
    }),
    [loadInitClientDataFail]: (state, action) => ({
      ...state,
      fail: action.payload.fail
    })
    
  },
  defaultState
);
